var _defs, _circle, _ellipse, _ellipse2, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnhappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "3.2 3.2 57.6 57.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    cx: 26.4,
    cy: 23.6,
    r: 39.2
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb08a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f2621c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b8380a"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "url(#m)",
    stroke: "#8a2a06",
    strokeWidth: 1.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23,
    cy: 33,
    rx: 4,
    ry: 6,
    fill: "#3a1000"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41,
    cy: 33,
    rx: 4,
    ry: 6,
    fill: "#3a1000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22 L29 31 L29 26 L13 18Z M52 22 L35 31 L35 26 L51 18Z",
    fill: "url(#m)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 16 Q22 17 29.5 24.5 M51 16 Q42 17 34.5 24.5",
    stroke: "#3a1000",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 49 L43 49 Q41 39.5 32 39.5 Q23 39.5 21 49Z",
    fill: "#8a0a0e",
    stroke: "#4a0606",
    strokeWidth: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6 48.4 L42.4 48.4 L42 45.8 Q32 44.3 22 45.8Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnhappy);
export default __webpack_public_path__ + "static/media/unhappy.02b1e4fa6d7398bd242b3e7a2c96894a.svg";
export { ForwardRef as ReactComponent };